<template>
	<b-form-group class="labeled-input" :label="label" :label-for="inputId" :id="id || ''" :class="cssClass">

		<b-input-group v-if="type !== 'select'" :prepend="prepend" :append="append" :size="size" ref="formControl">

      <template #prepend v-if="$slots.prepend">
        <slot name="prepend"/>
      </template>

      <template #append v-if="$slots.append">
        <slot name="append"/>
      </template>

			<slot :validationState="validationState">

				<blumar-decimal-input v-if="type === 'decimal'"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					v-model="localValue"
					:size="size || 'md'" :class="inputClass"
					:allowNegative="allowNegative"
					:tabindex="tabindex || undefined"
					:state="validationState"
					/>

				<b-form-input v-else-if="type === 'date'"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					v-model="localValue"
					:size="size || 'md'" :class="inputClass"
					v-mask="'99/99/9999'"
					:tabindex="tabindex || undefined"
					:state="validationState"
					/>

				<b-form-input v-else-if="mask"
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					v-model="localValue"
					:size="size || 'md'" :class="inputClass"
					v-mask="mask"
					:tabindex="tabindex || undefined"
					:state="validationState"
					/>

				<b-form-input v-else
					v-bind="$attrs" v-on="$listeners" :id="inputId"
					v-model="localValue"
					:type="type" :class="inputClass"
					:size="size || 'md'"
					:tabindex="tabindex || undefined"
					:state="validationState"
					/>

			</slot>

		</b-input-group>

		<slot v-else>
			<b-form-select
				v-bind="$attrs" v-on="$listeners" :id="inputId"
				v-model="localValue"
				:size="size || 'md'" :class="inputClass"
				:options="options" :textField="textField || 'name'" :valueField="valueField || 'id'"
				:tabindex="tabindex || undefined"
				:state="validationState"
				ref="formControl"
				/>
		</slot>

		<b-tooltip v-if="validationState === false" :target="$refs.formControl" triggers="hover">
			<slot name="error-message">
				<template v-for="({message}, k) of validation.$params">
					<div v-if="!validation[k]" :key="k">{{message}}</div>
				</template>
			</slot>
		</b-tooltip>

	</b-form-group>
</template>

<script>
import mask from 'awesome-mask';
import moment from 'moment';

export default {
	directives: { mask },
	props: ['value', 'type', 'label', 'id', 'inputClass', 'cssClass', 'options', 'textField', 'valueField', 'prepend', 'append', 'size', 'allowNegative', 'mask', 'tabindex', 'validation', 'errorMessage', 'inputRef'],
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set($event) {
				this.$emit('input', $event);
			},
		},
		inputId() {
			if (this.id)
				return this.id + '-input';
			return '';
		},
		validationState() {
			return this.computeValidationState();
		}
	},
	methods: {
		formatDate(format) {
			return moment(this.value, 'DD/MM/YYYY').format(format);
		},
		isoDate() {
			return this.formatDate('YYYY-MM-DD');
		},
		formatNumber() {
			return this.value.replace(',', '.');
		},
		computeValidationState() {
			return this.validation && this.validation.$dirty && this.validation.$invalid ? false : undefined;
		},
	},
}
</script>

<style scoped lang="scss">
.labeled-input {
  & >>> legend {
    font-weight: bold;
  }

  & >>> .bv-no-focus-ring {
    width: 100%;
  }

  & >>> select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LabeledInput.vue